import React from 'react';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';
import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import './GroupBuyStatusCustomComponent.less';

/**
 * type: 'group-buy-status'
 * 组件：拼团状态组件
 */
export default class GroupBuyStatusCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {

  }

  catchGroupList = (e) => {
    let that = this;
    let index = e.currentTarget.dataset.index;
    let compindex = e.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let param = {
      page: 1,
      status: e.currentTarget.dataset.index || 0,
    };
    let listId = pageInstance.data.eles[compindex].customFeature.status_refresh_object;
    let groupCompindex = app.findComponentIndexById(listId)
    if(groupCompindex === -1){
      app.showModal({content: '找不到绑定的拼团列表'});
      return;
    }
    if (pageInstance.newClassifyGroupidsParams && !!pageInstance.newClassifyGroupidsParams.length) {
      let params = pageInstance.newClassifyGroupidsParams;
      for (let i = 0; i < params.length; i++) {
        let newClassifyCompid = params[i].compindex;
        let newClassifyCompData = pageInstance.data.eles[newClassifyCompid];
        if (newClassifyCompData.customFeature.refresh_object == pageInstance.data.eles[groupCompindex].customFeature.id) {
          param.idx_arr = {
            idx: 'category',
            idx_value: newClassifyCompData.selectedCateId
          };
        }
      }
    }
    let newdata = {};
    newdata['eles[' + compindex + '].customFeature.selectNum'] = index;
    newdata['eles[' + groupCompindex + '].selectNum'] = index;
    pageInstance.setData(newdata);
    pageInstance.callComponentMethod({
      componentIndex: groupCompindex,
      methodName: 'getGroupBuyList',
      argvs: [groupCompindex, param]
    });
  }  

  render() {
    const data = this.props.data;
    const { customFeature, style } = data;
    const {
      fontSize, fontColor, fontWeight,
      fontStyle, textDecoration, mode,
      background, checkOptionsOne, checkedNum,
      selectColor, selectFontStyle, selectTextDecoration,
      defalutColor: defaultColor
    } = customFeature;

    /**
     * @desc 处理拼团状态组件选中问题
     */
    let selectNum = customFeature.selectNum || 0;

    const styleObj = {
      fontSize,
      color: fontColor,
      fontWeight,
      fontStyle,
      textDecoration
    };

    const tabBarStyle = {
      ...styleObj,
      ...convertStyleData(style),
    };

    // tabbar-list1样式
    const selectStyle = {
      color: selectColor,
      borderBottom: `.04rem solid ${selectColor}`,
      fontStyle: selectFontStyle,
      textDecoration: selectTextDecoration
    };

    // tabbar-list2样式
    const selectStyleTwo = {
      background: selectColor,
      color: '#fff',
      fontStyle: selectFontStyle,
      textDecoration: selectTextDecoration
    };

    /**
     * @desc tabBar列表
     */
    const tabBarList = () => {
      const config = {
        1: {
          name: 'tabbar-list1',
          style: selectStyle
        },
        2: {
          name: 'tabbar-list2',
          style: selectStyleTwo
        }
      }[mode];
      return (
        <div className={`tabbar-list ${config.name}`} style={tabBarStyle}>
          {checkOptionsOne.map((item, index) => {
            return (item.checked &&
              <div
                className="item"
                key={item.value}
                style={{ minWidth: checkedNum == 2 ? '3.75rem' : (checkedNum == 3 ? '2.5rem' : '1.87rem') }}
                data-index={index}
                data-compindex={this.props.index}
                data-status="0"
                onClick={this.catchGroupList}>
                <div style={selectNum == index ? { ...config.style } : { color: defaultColor }}>{item.label}</div>
              </div>
            )
          })}
        </div>
      )
    };

    return (
      <div className="custom-component group-buy-status">
        <div style={styleObj}
          className="group-status-list">
          <div className="list-status">
            <ScrollView scroll-x="true" className="s-view" style={{'background':data.customFeature.background,width:'100%',whiteSpace:'nowrap',textDecoration:'inherit',overflowX:'scroll','overflowY':'hidden'}}>
              {tabBarList()}
            </ScrollView>
          </div>
        </div>
      </div >
    )
  }
}



// WEBPACK FOOTER //
// ./src/custom-component/group-buy-status-custom-component/GroupBuyStatusCustomComponent.jsx